import React from 'react';
import type { KpiItem } from '../../utils/kpis';
import { MetricInfoButton } from '../definitions/MetricInfoButton';
import { DeltaBadge } from './DeltaBadge';
export function KpiCard({
  item
}: {
  item: KpiItem;
}) {
  return <div className={`flex min-w-0 flex-col rounded-lg border bg-white px-4 py-3.5 ${item.emphasis ? 'border-navy/30' : 'border-line'}`} data-id="element-722" data-mp="216gttra3mcmr">
      <div className="flex items-start gap-1.5" data-id="element-723" data-mp="2640cr4hqrdl1">
        <span className="text-[12.5px] font-medium leading-snug text-ink-muted" data-id="element-724" data-mp="2a6wuyu3dd7og">{item.label}</span>
        <span className="mt-0.5" data-id="element-725" data-mp="2f5zvc18empq3">
          <MetricInfoButton id={item.definitionId} label={item.label} data-id="element-726" data-mp="2f4yeth8mdb0z" />
        </span>
      </div>
      <div className={`mt-2 font-semibold leading-none tracking-tight text-navy tabular-nums ${item.emphasis ? 'text-[28px]' : 'text-[24px]'}`} data-id="element-727" data-mp="2jzukhk6s3wwk">{item.value}</div>
      {item.deltas.length > 0 && <div className="mt-3 flex flex-wrap gap-x-3 gap-y-1" data-id="element-728" data-mp="2ttumhd6rkm12">
          {item.deltas.map(d => <DeltaBadge key={d.label} value={d.value} kind={d.kind} label={d.label} data-id="element-729" data-mp="2xvg7xmxd68mv" />)}
        </div>}
      <div className="mt-auto break-words pt-2.5 text-[11px] leading-snug text-ink-subtle" data-id="element-730" data-mp="1tu7b5le6wd03">{item.caption}</div>
    </div>;
}